import { ArrowClockwise } from "@phosphor-icons/react";

/**
 * V7.1: Indicador visual do pull-to-refresh. Renderiza um spinner que cresce/gira
 * conforme `progress` (0..1). Some quando não está puxando nem atualizando.
 */
export default function PullIndicator({ pulling, progress, refreshing }) {
  if (!pulling && !refreshing) return null;
  const angle = (progress || 0) * 360;
  const scale = Math.max(0.6, Math.min(1, progress || 0));
  return (
    <div
      className="fixed top-0 left-0 right-0 flex items-start justify-center pointer-events-none z-40"
      style={{ paddingTop: `calc(env(safe-area-inset-top, 0px) + ${refreshing ? 16 : Math.max(6, 16 * (progress || 0))}px)` }}
      data-testid="pull-indicator"
    >
      <div
        className="bg-white rounded-full shadow-md p-2 border border-slate-200 transition-transform"
        style={{ transform: `scale(${scale})` }}
      >
        <ArrowClockwise
          size={20}
          weight="bold"
          className={`text-[#004E98] ${refreshing ? "animate-spin" : ""}`}
          style={{ transform: refreshing ? undefined : `rotate(${angle}deg)`, transition: "transform 0.1s" }}
        />
      </div>
    </div>
  );
}
